/**
 * The path a completed sign-in should land on, carried as the OIDC request's own `state`
 * (`oidc-client-ts` round-trips it back on `User.state`, untouched by the provider). `state` is
 * opaque to the OIDC spec, so it is untrusted here: only a path that resolves on this origin
 * survives. The check is the browser's own resolution, not a prefix test — `/\evil.example`
 * starts with a single slash yet resolves off-origin, exactly like `//evil.example`.
 */
export const safeRedirectTarget = (state: unknown, origin = window.location.origin): string | null => {
    if (typeof state !== 'string' || !state.startsWith('/')) return null;
    try {
        return new URL(state, origin).origin === origin ? state : null;
    } catch {
        return null;
    }
};
